import React from "react";
export default function Events() {
  return (
    <div className="container my-4">
      <h2>Events</h2>
      <p>Events section will be updated soon.</p>
    </div>
  );
}
